//App
import { OrganizationApiType } from "./types/apiTypes";
import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";

const organizationApi: OrganizationApiType = {
  getLookups: () => apiClient.get(endPoints.organization.getLookups()),
  get: (value) => apiClient.get(endPoints.organization.get(value)),
  getAll: (payload) => apiClient.get(endPoints.organization.getAll(), payload),
  save: (payload) => apiClient.post(endPoints.organization.save(), payload),
  delete: (value) => apiClient.delete(endPoints.organization.delete(value)),
  activate: (value) => apiClient.post(endPoints.organization.activate(value)),
  deactivate: (value) => apiClient.delete(endPoints.organization.deActivate(value)),
  searchOrganizations: (payload) => apiClient.post(endPoints.organization.searchOrganizations(), payload),

  getOrganizationCampaign: (value) => apiClient.get(endPoints.campaign.getOrganizationCampaign(value)),
  getOrganizationCampaignLookups: () => apiClient.get(endPoints.campaign.getOrganizationCampaignLookups()),
  searchOrganizationCampaign: (payload) => apiClient.post(endPoints.campaign.searchOrganizationCampaign(), payload),
  saveOrganizationCampaign: (payload) => apiClient.post(endPoints.campaign.saveOrganizationCampaign(), payload),
  activateOrganizationCampaign: (value) => apiClient.post(endPoints.campaign.activateOrganizationCampaign(value)),
  deactivateOrganizationCampaign: (value) => apiClient.post(endPoints.campaign.deactivateOrganizationCampaign(value)),
  sendEmployeeMail: (value) => apiClient.post(endPoints.campaign.sendEmployeeMail(value)),
  searchDonors:(payload) => apiClient.post(endPoints.campaign.searchDonors(), payload),

  UploadEmployees: (payload) => apiClient.post(endPoints.employee.UploadEmployees(), payload, true),
  getFailedEmployeeUploadRequest: () => apiClient.get(endPoints.employee.getFailedEmployeeUploadRequests()),
  getEmployeeLookups: () => apiClient.get(endPoints.employee.getEmployeeLookups()),
  getEmployee: (value) => apiClient.get(endPoints.employee.getEmployee(value)),
  saveEmployee: (payload) => apiClient.post(endPoints.employee.saveEmployee(), payload),
  activateEmployee: (value) => apiClient.post(endPoints.employee.activateEmployee(value)),
  deactivateEmployee: (value) => apiClient.post(endPoints.employee.deactivateEmployee(value)),
  searchEmployee: (payload) => apiClient.post(endPoints.employee.searchEmployee(), payload),
  sendPledgeReminderMail: (payload) => apiClient.post(endPoints.employee.sendPledgeReminderMail(), payload),
  getOrganizationEmployeeUploadTemplate: (value) => endPoints.organization.getOrganizationEmployeeUploadTemplate(value),
};

export default organizationApi;